import { PersonOutline } from '@lyearn/icons';
import { Input, RenderInputParams } from '@lyearn/ui';
import { UserFragment } from '@/graphql/fragments/generated/User';

export const renderInput = (value: UserFragment[], params: RenderInputParams) => {
  const { startAdornment, ...restInputParams } = params;

  return (
    <Input
      {...restInputParams}
      startAdornment={
        <>
          {!value?.length ? (
            <PersonOutline className="h-24 w-24" fillColorToken="icon-placeholder" />
          ) : null}
          {startAdornment}
        </>
      }
    />
  );
};
